<p-dialog
  [visible]="visible"
  (onHide)="hide()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '460px' }"
  styleClass="edit-folio-dialog"
  header="Editar número del folio">

  <form [formGroup]="form" class="edit-folio-form">
    <!-- Aviso de trazabilidad -->
    <div class="warn-box">
      <i class="pi pi-info-circle"></i>
      <span>
        Solo se edita el <strong>primer número</strong> del folio (el <code>oldId</code>).
        El folio anterior completo se guardará en <code>oldId</code> para conservar la
        trazabilidad histórica.
      </span>
    </div>

    <div class="field">
      <label for="folioDigit">{{ modeLabel }}</label>
      <div class="folio-editor">
        <span class="folio-part">{{ parsed?.prefix || 'R-' }}</span>
        <input
          id="folioDigit"
          type="text"
          pInputText
          formControlName="digit"
          inputmode="numeric"
          [maxlength]="maxLen"
          placeholder="0"
          class="folio-digit-input"
          (input)="onDigitInput($event)" />
        <span class="folio-part" *ngIf="parsed">-{{ parsed.rest }}</span>
      </div>
      <small class="p-error" *ngIf="form.get('digit')?.invalid && form.get('digit')?.touched">
        El primer número del folio debe tener entre 1 y 3 dígitos.
      </small>
      <small class="preview" *ngIf="previewFolio">
        Nuevo folio: <strong>{{ previewFolio }}</strong>
      </small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="hide()" [disabled]="loading"></button>
    <button pButton type="button" label="Guardar" icon="pi pi-check" (click)="save()" [disabled]="loading || !canSave" [loading]="loading"></button>
  </ng-template>
</p-dialog>
